import React from "react";
import { MONEDAS } from "../propuestaComercialGenerator";
import { soloDigitosCelular } from "./constantes";

const PropuestaComercialModal = ({
  firmante,
  setFirmante,
  moneda,
  setMoneda,
  errorPropuesta,
  generandoPropuesta,
  propuestaBlob,
  firmanteCompleto,
  onCancelar,
  onConfirmar,
}) => {
  return (
    <div className="docgen-revision-overlay" role="dialog" aria-modal="true">
      <div className="docgen-revision-modal docgen-firmante-modal">
        <div className="docgen-revision-header">
          <h2 className="docgen-revision-title">Datos del firmante</h2>
          <p className="docgen-revision-subtitle">
            Se usan para la firma final de la propuesta comercial y pueden
            cambiar en cada proyecto.
          </p>
        </div>
        <div className="docgen-revision-body">
          <input
            type="text"
            className="docgen-name-input"
            placeholder="Nombre completo"
            value={firmante.nombre}
            onChange={(event) =>
              setFirmante((prev) => ({ ...prev, nombre: event.target.value }))
            }
            autoFocus
          />
          <input
            type="text"
            className="docgen-name-input"
            placeholder="Puesto"
            value={firmante.puesto}
            onChange={(event) =>
              setFirmante((prev) => ({ ...prev, puesto: event.target.value }))
            }
          />
          <input
            type="email"
            className="docgen-name-input"
            placeholder="Correo"
            value={firmante.correo}
            onChange={(event) =>
              setFirmante((prev) => ({ ...prev, correo: event.target.value }))
            }
          />
          <input
            type="text"
            className="docgen-name-input"
            placeholder="Celular"
            inputMode="numeric"
            maxLength={10}
            value={firmante.celular}
            onChange={(event) =>
              setFirmante((prev) => ({
                ...prev,
                celular: soloDigitosCelular(event.target.value),
              }))
            }
          />

          <div className="docgen-empresa-label">Moneda</div>
          <p className="orgproc-card-desc">
            Define en qué moneda se expresan los precios y los datos de
            pago de la propuesta.
          </p>
          <div className="docgen-moneda-selector" role="radiogroup" aria-label="Moneda">
            {Object.keys(MONEDAS).map((codigo) => (
              <button
                key={codigo}
                type="button"
                role="radio"
                aria-checked={moneda === codigo}
                className={
                  "docgen-moneda-option" +
                  (moneda === codigo ? " docgen-moneda-option--activa" : "")
                }
                onClick={() => setMoneda(codigo)}
              >
                {MONEDAS[codigo].nombre} ({codigo})
              </button>
            ))}
          </div>

          {errorPropuesta && (
            <p className="docgen-output-hint docgen-output-hint--error">{errorPropuesta}</p>
          )}
        </div>
        <div className="docgen-revision-footer">
          <button
            type="button"
            className="docgen-cancel-btn"
            onClick={onCancelar}
            disabled={generandoPropuesta}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={
              "orgproc-card-btn" +
              (firmanteCompleto && !generandoPropuesta ? "" : " orgproc-card-btn--disabled")
            }
            disabled={!firmanteCompleto || generandoPropuesta}
            onClick={onConfirmar}
          >
            {generandoPropuesta
              ? "Generando..."
              : propuestaBlob
              ? "Regenerar propuesta comercial"
              : "Generar propuesta comercial"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropuestaComercialModal;
